export default {
  props: {
    readonly: {
      description: 'A flag to forbid user input without visually disabling the input',
      type: Boolean,
    },
  },
};
